export const RESOURCES = [
  // Minerals
  {
    id: 'gold-sukari',
    name: 'منجم السكري',
    nameEn: 'منجم السكري',
    type: 'Gold',
    category: 'minerals',
    lat: 25.414,
    lng: 34.738,
    governorate: 'البحر الأحمر',
    description: 'أكبر منجم ذهب في مصر ومن أكبر 10 مناجم في العالم',
    importance: 5,
    images: ['https://via.placeholder.com/400x300'],
  },
  {
    id: 'phosphate-abu-tartur',
    name: 'مناجم أبو طرطور',
    nameEn: 'مناجم أبو طرطور',
    type: 'Phosphate',
    category: 'minerals',
    lat: 24.95,
    lng: 28.67,
    governorate: 'الوادي الجديد',
    description: 'من أكبر رواسب الفوسفات في العالم',
    importance: 4,
    images: ['https://via.placeholder.com/400x300'],
  },
  // Energy
  {
    id: 'gas-zohr',
    name: 'حقل ظهر',
    nameEn: 'حقل ظهر للغاز',
    type: 'NaturalGas',
    category: 'energy',
    lat: 31.78,
    lng: 32.75,
    governorate: 'بورسعيد',
    description: 'أكبر حقل غاز طبيعي في البحر المتوسط',
    importance: 5,
    images: ['https://via.placeholder.com/400x300'],
  },
  {
    id: 'solar-benban',
    name: 'محطة بنبان للطاقة الشمسية',
    nameEn: 'محطة بنبان للطاقة الشمسية',
    type: 'Solar',
    category: 'energy',
    lat: 24.48,
    lng: 32.73,
    governorate: 'أسوان',
    description: 'أكبر محطة طاقة شمسية في أفريقيا',
    importance: 5,
    images: ['https://via.placeholder.com/400x300'],
  },
  // Tourism
  {
    id: 'pyramids',
    name: 'أهرامات الجيزة',
    nameEn: 'أهرامات الجيزة',
    type: 'Archaeological',
    category: 'tourism',
    lat: 29.9792,
    lng: 31.1342,
    governorate: 'الجيزة',
    description: 'واحدة من عجائب الدنيا السبع القديمة',
    importance: 5,
    images: ['https://via.placeholder.com/400x300'],
  },
  {
    id: 'karnak',
    name: 'معابد الكرنك',
    nameEn: 'معابد الكرنك',
    type: 'Archaeological',
    category: 'tourism',
    lat: 25.7188,
    lng: 32.6573,
    governorate: 'الأقصر',
    description: 'أكبر مجمع معابد في العالم القديم',
    importance: 5,
    images: ['https://via.placeholder.com/400x300'],
  },
  // Agriculture
  {
    id: 'delta-rice',
    name: 'زراعة الأرز - الدلتا',
    nameEn: 'زراعة الأرز في الدلتا',
    type: 'Rice',
    category: 'agriculture',
    lat: 31.1107,
    lng: 30.9388,
    governorate: 'كفر الشيخ',
    description: 'من أهم مناطق زراعة الأرز في مصر',
    importance: 4,
    images: ['https://via.placeholder.com/400x300'],
  },
  {
    id: 'delta-cotton',
    name: 'حقول القطن',
    nameEn: 'حقول القطن',
    type: 'Cotton',
    category: 'agriculture',
    lat: 31.1656,
    lng: 31.4913,
    governorate: 'الدقهلية',
    description: 'القطن المصري من أجود الأنواع في العالم',
    importance: 4,
    images: ['https://via.placeholder.com/400x300'],
  }
];

export const RESOURCE_TYPE_LABELS = {
  Gold: 'ذهب',
  Phosphate: 'فوسفات',
  Iron: 'حديد',
  Oil: 'بترول',
  NaturalGas: 'غاز طبيعي',
  Solar: 'طاقة شمسية',
  Wind: 'طاقة رياح',
  Wheat: 'قمح',
  Cotton: 'قطن',
  Rice: 'أرز',
  Archaeological: 'موقع أثري',
  Beach: 'شاطئ'
};

export const getCategoryColor = (category) => {
  const colors = {
    minerals: '#D4AF37',
    energy: '#1E88E5',
    agriculture: '#66BB6A',
    tourism: '#FFA726'
  };
  return colors[category] || '#7F8C8D';
};

export const getCategoryIcon = (type) => {
  const icons = {
    Gold: '🪙',
    Phosphate: '⚫',
    Iron: '🔩',
    Oil: '🛢️',
    NaturalGas: '🔥',
    Solar: '☀️',
    Wind: '💨',
    Wheat: '🌾',
    Cotton: '🌱',
    Rice: '🍚',
    Archaeological: '🏛️',
    Beach: '🏖️'
  };
  return icons[type] || '📍';
};

export const getResourceTypeLabel = (type) => RESOURCE_TYPE_LABELS[type] || 'نوع متنوع';
